import type { ActionReturn } from "svelte/action";

export function updateTextareaHeight(textarea: HTMLTextAreaElement): ActionReturn {
	const cloned = textarea.cloneNode(true) as HTMLTextAreaElement;
	cloned.style.setProperty("position", "fixed", "important");
	cloned.style.setProperty("visibility", "hidden", "important");
	cloned.style.setProperty("pointer-events", "none", "important");
	cloned.dataset.felteIgnore = "true";
	cloned.style.height = "auto";
	cloned.style.top = "0";
	cloned.style.left = "0";
	cloned.style.right = "0";
	cloned.name = "";
	cloned.id = "";
	cloned.addEventListener("invalid", (event) => {
		event.preventDefault();
	});
	textarea.parentElement?.appendChild(cloned);

	function update(): void {
		cloned.value = textarea.value;
		const computedStyle = getComputedStyle(cloned);
		const borderWidth =
			Math.round(parseFloat(computedStyle.borderTopWidth)) + Math.round(parseFloat(computedStyle.borderBottomWidth));
		textarea.style.height = `${cloned.scrollHeight + borderWidth}px`;
	}

	setTimeout(() => {
		update();
	}, 0);
	// Sometimes checking once is not enough :'( Couldn't figure out (in a fast way) how to do it properly.
	setTimeout(() => {
		update();
	}, 1);
	textarea.addEventListener("input", update);

	return {
		destroy(): void {
			textarea.removeEventListener("input", update);
			cloned.remove();
		},
	};
}
